// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__4wHD-","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__eMg1L"};